"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _error = _interopRequireDefault(require("./error"));

var _flat = _interopRequireDefault(require("./flat"));

var _flatPrimary = _interopRequireDefault(require("./flatPrimary"));

var _primary = _interopRequireDefault(require("./primary"));

var _primaryInversion = _interopRequireDefault(require("./primaryInversion"));

var _secondary = _interopRequireDefault(require("./secondary"));

var _tag = _interopRequireDefault(require("./tag"));

var _tagPrimary = _interopRequireDefault(require("./tagPrimary"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var basic = function basic(palette) {
  return {
    palette: palette,
    display: 'inline-block',
    animationDisplay: 'block',
    animationBackgroundColor: palette.elLight,
    minWidth: palette.gutter * 5 + 'px',
    width: 'auto',
    borderRadius: '2px',
    fontSize: palette.tsNormal,
    fontWeight: palette.twSemi,
    lineHeight: 1.5,
    fontFamily: palette.fontFamily,
    color: palette.tInactive,
    textAlign: 'left',
    borderColor: palette.elPrimary,
    background: palette.elPrimary,
    boxShadow: "0 2px 4px 0 ".concat(palette.elShadowMain),
    paddingTop: palette.gutter + 'px',
    paddingBottom: palette.gutter + 'px',
    paddingRight: palette.gutter * 2 + 'px',
    paddingLeft: palette.gutter * 2 + 'px',
    whiteSpace: 'nowrap',
    borderStyle: 'none',
    borderWidth: 0,
    rootBackground: '#FFF',
    height: 'auto',
    wordBreak: 'normal',
    focusColor: palette.tInactive,
    focusBorderColor: palette.elPrimary,
    focusBackground: palette.elPrimary,
    focusBoxShadow: "0 2px 4px 0 ".concat(palette.elShadowMain),
    hoverColor: palette.tFilled,
    hoverBorderColor: palette.elLightest,
    hoverBackground: palette.elLightest,
    hoverBoxShadow: "0 2px 4px 0 ".concat(palette.elShadowMain),
    activeColor: palette.tActive,
    activeBorderColor: palette.elPrimary,
    activeBackground: palette.elPrimary,
    activeBoxShadow: "0 8px 8px 0 ".concat(palette.elShadow, ", 0 0 8px 0 ").concat(palette.elShadow),
    disabledColor: palette.tDisabled,
    disabledBorderColor: palette.elLightest,
    disabledBackground: palette.elLightest,
    disabledBoxShadow: 'none'
  };
};

function _default(palette) {
  var basicStyle = basic(palette);
  return _objectSpread({}, basicStyle, {
    error: _objectSpread({}, basicStyle, {}, (0, _error["default"])(palette)),
    flat: _objectSpread({}, basicStyle, {}, (0, _flat["default"])(palette)),
    flatPrimary: _objectSpread({}, basicStyle, {}, (0, _flatPrimary["default"])(palette)),
    primary: _objectSpread({}, basicStyle, {}, (0, _primary["default"])(palette)),
    primaryInversion: _objectSpread({}, basicStyle, {}, (0, _primaryInversion["default"])(palette)),
    secondary: _objectSpread({}, basicStyle, {}, (0, _secondary["default"])(palette)),
    tag: _objectSpread({}, basicStyle, {}, (0, _tag["default"])(palette)),
    tagPrimary: _objectSpread({}, basicStyle, {}, (0, _tagPrimary["default"])(palette))
  });
}